import {ASSET_PREFIX} from "../utils/constants";

const LoadingSpinner = ({ loadingText, style = {} }) => {
  return (
    <div className="loadingSpinner flexCentered" style={{ ...style }}>
      <img src={`${ASSET_PREFIX}/images/loading.png`} />
      <p style={{
        fontFamily: '-apple-system, sans-serif',
        fontWeight: '600',
        color: '#666'
      }}>
        {loadingText}
      </p>

      <style jsx>{`
        .loadingSpinner {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          background-color: #F8FAFF;
        }
        
        img {
          width: 100px;
        }
        
        @media(min-width: 800px) {
          img {
            width: 150px;
          }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;
